import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { getEvents } from "store/vino/eventsSlice";
import WineEventsList from "./WineEventsList";

const Root = styled("div")(({ theme }) => ({
	"& .SubscriptionPage-header": {
		height: 600,
		background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
		color: theme.palette.primary.contrastText,
	},
	"& .SubscriptionPage-badge": {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.getContrastText(theme.palette.error.main),
	},
}));

const WineEvents = () => {
	const dispatch = useDispatch();
	const events = useSelector(({ vino }) => vino.events.list);

	useEffect(() => {
		dispatch(getEvents());
	}, [dispatch]);

	return (
		<Root className="w-full">
			<div className="w-full max-w-2xl mx-auto">
				<WineEventsList events={events} />
			</div>
		</Root>
	);
};

export default WineEvents;
